module.exports = {
    REACT_APP_API_URL: 'http://crop.softdigisolutions.com/api',
    REACT_APP_BASE_PATH: "/admin",
    REACT_APP_ENV: 'development',
    ENCRYPTION_KEY : 'your-secret-key'
  };